import { render, staticRenderFns } from "./Leadsource.vue?vue&type=template&id=650dd398"
import script from "./Leadsource.vue?vue&type=script&lang=js"
export * from "./Leadsource.vue?vue&type=script&lang=js"
import style0 from "./Leadsource.vue?vue&type=style&index=0&id=650dd398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports